import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, Navigate, useParams, useLocation } from 'react-router-dom';
import LandingPage from './pages/LandingPage';
import Dashboard from './pages/DashboardNew';
import Lesson from './pages/LessonNew';
import Leaderboard from './pages/LeaderboardNew';
import LeaderboardPage from './pages/LeaderboardPage';
import FamilyPage from './pages/FamilyPage';
import ProfileSelectPage from './pages/ProfileSelectPage';
import Login from './pages/Login';
import Signup from './pages/Signup';
import Pricing from './pages/Pricing';
import PaymentSuccess from './pages/PaymentSuccess';
import BadgesPage from './pages/BadgesPage';
import GoalsPage from './pages/GoalsPage';
import PromoCode from './pages/PromoCode';
import Settings from './pages/Settings';
import AdminDashboard from './pages/AdminDashboard';
import Contact from './pages/Contact';
import LegalMentions from './pages/LegalMentions';
import PrivacyPolicy from './pages/PrivacyPolicy';
import ProtectedRoute from './components/ProtectedRoute';
import AuthCallback from './components/AuthCallback';
import { LanguageProvider } from './i18n/LanguageContext';

// Wrapper component to force remount when lessonId changes
const LessonWrapper = () => {
  const { lessonId } = useParams();
  const location = useLocation();
  
  // Force component remount when lessonId changes by using it as key
  return <Lesson key={`${lessonId}-${location.search}`} />;
};

// Router wrapper to detect OAuth callback
const AppRouter = () => {
  const location = useLocation();
  
  // Detect session_id in URL fragment (synchronous check during render)
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/pricing" element={<Pricing />} />
      <Route path="/promo" element={<PromoCode />} />
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/payment/success" element={<ProtectedRoute><PaymentSuccess /></ProtectedRoute>} />
      <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/lesson/:lessonId" element={<ProtectedRoute><LessonWrapper /></ProtectedRoute>} />
      <Route path="/leaderboard" element={<ProtectedRoute><LeaderboardPage /></ProtectedRoute>} />
      <Route path="/family" element={<ProtectedRoute><FamilyPage /></ProtectedRoute>} />
      <Route path="/profiles" element={<ProtectedRoute><ProfileSelectPage /></ProtectedRoute>} />
      <Route path="/badges" element={<ProtectedRoute><BadgesPage /></ProtectedRoute>} />
      <Route path="/goals" element={<ProtectedRoute><GoalsPage /></ProtectedRoute>} />
      <Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
      <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/legal" element={<LegalMentions />} />
      <Route path="/privacy" element={<PrivacyPolicy />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

function App() {
  return (
    <LanguageProvider>
      <div className="App">
        <BrowserRouter>
          <AppRouter />
        </BrowserRouter>
      </div>
    </LanguageProvider>
  );
}

export default App;